import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BooleanInput } from '@ptl/global-components';
import { MessageCatalogModalTriggerService } from './services/message-catalog-modal-trigger.service';
import { ContentStorageService } from '@ptl/global-components';
import { messageCatalogModalContentKey } from './enums/message-catalog-modal-trigger.enum';
import { Subscription } from 'rxjs';
import { clearPlanDetails } from 'src/app/angular-elements/plan-selection/configs/reducers/plan-details.reducer';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';

@Component({
  selector: 'app-message-catalog-modal-trigger',
  templateUrl: './message-catalog-modal-trigger.component.html',
  styleUrl: './message-catalog-modal-trigger.component.scss',
  standalone: false
})
export class MessageCatalogModalTriggerComponent implements OnInit, OnDestroy{

  @Input() @BooleanInput() showModalOnPageLoad: boolean;
  @Input() modalHeading: string;
  @Input() @BooleanInput() newTabRightButtonUrl: boolean;
  @Input() rightButtonLabel: string;  
  @Input() rightButtonRedirectUrl: string;
  @Input() @BooleanInput() showLeftButton: boolean;
  @Input() @BooleanInput() newTabLeftButtonUrl: boolean;
  @Input() leftButtonLabel: string;
  @Input() leftButtonRedirectUrl: string;
  @Input() emphasizedText: string;
  @Input() displayPage: string;

  @Input() @BooleanInput() showModalOnEnroll: boolean;
  @Input() enrollModalHeading: string;
  @Input() @BooleanInput() enrollNewTabRightButtonUrl: boolean;
  @Input() enrollRightButtonLabel: string;  
  @Input() enrollRightButtonRedirectUrl: string;
  @Input() @BooleanInput() enrollShowLeftButton: boolean;
  @Input() @BooleanInput() enrollNewTabLeftButtonUrl: boolean;
  @Input() enrollLeftButtonLabel: string;
  @Input() enrollLeftButtonRedirectUrl: string;
  @Input() enrollEmphasizedText: string;

  messageCatalogDisplaySubscription: Subscription;

  constructor(
    private messageModalTriggerService: MessageCatalogModalTriggerService,
    private contentStorageService: ContentStorageService,
    private ngRedux: NgRedux<StateStructure>
  ) { }

  ngOnInit() {
    const messageModalContent = this.storeConfigs();

    if(this.displayPage === 'viewPlans'){
      this.ngRedux.dispatch(clearPlanDetails());
    }

    if(this.showModalOnPageLoad){
      const checkPlanAndZip = this.messageModalTriggerService.checkPlanAndZipMessages(messageModalContent);
      this.messageCatalogDisplaySubscription = this.messageModalTriggerService.displayResponseSubject.subscribe(response => {
        if (response[0] && response[0].size > 0 && response[1] === false) {
          this.messageModalTriggerService.openMessageCatalogModal(messageModalContent, response[0], response[1]);
        }else {
          console.error("No Messages Found to Display");
        }
      });    
    }
  }

  ngOnDestroy(): void {
    if(this.messageCatalogDisplaySubscription) { this.messageCatalogDisplaySubscription.unsubscribe();}
  }

  storeConfigs(){
    try {
      const messageCatalogConfigs: [string, any][] = [
        ["showModalOnPageLoad", this.showModalOnPageLoad],
        ["modalHeading", this.modalHeading],
        ["newTabRightButtonUrl", this.newTabRightButtonUrl],
        ["rightButtonLabel", this.rightButtonLabel],
        ["rightButtonRedirectUrl", this.rightButtonRedirectUrl],
        ["showLeftButton", this.showLeftButton],
        ["newTabLeftButtonUrl", this.newTabLeftButtonUrl],
        ["leftButtonLabel", this.leftButtonLabel],
        ["leftButtonRedirectUrl", this.leftButtonRedirectUrl],
        ["emphasizedText", this.emphasizedText],
        ["displayPage", this.displayPage],
        //enroll button specific configs
        ["showModalOnEnroll", this.showModalOnEnroll],
        ["enrollModalHeading", this.enrollModalHeading],
        ["enrollNewTabRightButtonUrl", this.enrollNewTabRightButtonUrl],
        ["enrollRightButtonLabel", this.enrollRightButtonLabel],
        ["enrollRightButtonRedirectUrl", this.enrollRightButtonRedirectUrl],
        ["enrollShowLeftButton", this.enrollShowLeftButton],
        ["enrollNewTabLeftButtonUrl", this.enrollNewTabLeftButtonUrl],
        ["enrollLeftButtonLabel", this.enrollLeftButtonLabel],
        ["enrollLeftButtonRedirectUrl", this.enrollLeftButtonRedirectUrl],
        ["enrollEmphasizedText", this.enrollEmphasizedText],

      ]
      const parsedContent: Map<string, any> = new Map(messageCatalogConfigs.map(obj => [obj[0], obj[1]]));
      this.contentStorageService.storeContentMapFromComponent(messageCatalogModalContentKey, parsedContent);

      return parsedContent;
          
    } catch (err) {
      console.log('JSON Content Parse and Map Error:', err);
    }
  }


}
